export default class CustomerBankDetails {
  constructor (customerId, type) {
    this.actions = {
      create: 'createCustomerBankDetails',
      update: 'updateCustomerBankDetails',
      remove: 'deleteCustomerBankDetails'
    }

    this.requestData = { customerId, type }
    this.name = 'bankDetails'
  }

  isNew (data) {
    return data.id === null || data.id === undefined
  }

  isEmpty (data) {
    return data.accountNumber === '' || data.accountNumber === null || data.accountNumber === undefined
  }

  static empty () {
    return {
      id: null,
      label: '',
      accountOwner: '',
      accountNumber: '',
      bankName: '',
      bankIdentifier: ''
    }
  }

  static parse (data) {
    return {
      id: data.id,
      label: data.label || '',
      accountOwner: data.accountOwner || '',
      accountNumber: data.accountNumber || '',
      bankName: data.bankName || '',
      bankIdentifier: data.bankIdentifier || ''
    }
  }

  static parseResponseData (response) {
    let bankDetails = response.bankDetails

    response.bankDetails = (bankDetails && bankDetails.data && bankDetails.data.length > 0)
      ? bankDetails.data.map(CustomerBankDetails.parse)
      : []

    return response
  }
}
